import React from "react";
import "./mobileHome.css";

function Button() {
    return (
        <button className="btn">EXPLORE</button>
    )
}

export default Button;